import CampusClient from '@/api/CampusClient';

const PageBy = {
  FeedbackByIdDesc: 'FeedbackByIdDesc',
  FeedbackByUpdatedDesc: 'FeedbackByUpdatedDesc'
}

export default class FeedbackReport {
  constructor() {
    this.campusClient = null;
    this.schoolId = 0;
    this.loading = false;

    this.token = undefined;

    this.parameters = {
      pageToken: PageBy.FeedbackByUpdatedDesc
    };

    this.feedbacks = [];
  }

  get error() {
    return this.token && this.token.error;
  }

  get hasNext() {
    return !!this.parameters.pageToken
      && this.parameters.pageToken != PageBy.FeedbackByUpdatedDesc;
  }

  initialize($http, schoolId) {
    this.campusClient = new CampusClient($http);
    this.schoolId = schoolId;

    return this;
  }

  reset() {
    this.parameters.pageToken = PageBy.FeedbackByUpdatedDesc;
    return this.fetch();
  }

  fetch() {
    if(!this.parameters.pageToken || this.parameters.pageToken === PageBy.FeedbackByUpdatedDesc)
      this.feedbacks.length = 0;
    return this.#callAsyncAndIgnorePreviousCalls(
      this.#getData.bind(this), 
      this.#handleResponse.bind(this));
  }

  async #callAsyncAndIgnorePreviousCalls(call, onsuccess) {
    if (this.token) {
      this.token.canceled = true;
    }

    const localToken = {
      error: undefined,
      canceled: false
    };
    this.token = localToken;

    try {
      const result = await call()

      if (localToken.canceled) {
        return;
      }

      onsuccess(result);

    } catch (error) {
      localToken.error = error;
      throw error;
    }
  }

  #getData() {
    this.loading = true;

    return this.campusClient.getFeedbackReport(
      this.schoolId,
      this.parameters.pageToken
    );
  }

  #handleResponse(response){
    this.parameters.pageToken = response.nextPageToken;
    this.feedbacks.push(...response.studentFeedback)
    this.loading = false;
  }
}
